import { Component, h } from 'preact'
import IdeaCard from './ideaCard'
import { Idea } from '../Types'

const headerHeight = 56

interface Props {
  ideaStatusTitle: string,
  ideaList: Array<Idea>,
  maxHeight: number,
  currentUserId: number,
  isGuest: boolean
}

class IdeationColumn extends Component<Props> {
  getWrapperStyles() {
    return {
      'max-height': this.props.maxHeight - headerHeight, //height of the header
      'overflow-y': 'scroll'
    }
  }

  render ({ ideaStatusTitle, ideaList, currentUserId, isGuest }: Props) {
    if (ideaList.length < 1) return null
    
    return (
      <div className={'pipeline__column-wrapper'}>
        <div className={'pipeline__column-header'}>
          <h5 className={'pipeline__column-title'}>
            {ideaStatusTitle} {ideaList.length > 0 ? `(${ideaList.length})` : ''}
          </h5>
        </div>
        <div className={'pipeline__ideation-list-wrapper'} style={this.getWrapperStyles()}>
          {ideaList.map((idea: Idea) => {
            return <IdeaCard
              voteSet={idea.voteSet}
              currentUserId={currentUserId}
              title={idea.title}
              ideaId={idea.id}
              author={idea.author} 
              votes={idea.votes}
              isGuest={isGuest}
              />
          })}
        </div>
      </div>
    )
  }
}

export default IdeationColumn
